module.exports = __webpack_public_path__ + "static/media/bg1.b1648ef8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/contents/editorPreview/layout/components/Layout/bg/bg1.jpg
// module id = 3306
// module chunks = 0